import { Grid, useTheme } from '@mui/material';
import { Link } from 'react-router-dom';

import { faSignature } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { SolidButton, StyledHeader, StyledParagraph } from './styles';

export function SignQuote({ quote }: any) {
  const theme = useTheme();
  return (
    <Grid container columnSpacing={2} rowSpacing={2}>
      <Grid
        item
        md={3}
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <FontAwesomeIcon
          icon={faSignature}
          size="4x"
          color={theme.palette.common.gunmetalBlue}
        />
      </Grid>
      <Grid item md={9}>
        <StyledHeader>Sign</StyledHeader>
        <StyledParagraph>
          Quote has been approved by your agent and is ready for signature
        </StyledParagraph>
        <Link
          style={{ display: 'block' }}
          to={`/customer/quotes/${quote.id}/attest/${quote.product}`}
        >
          <SolidButton
            type="submit"
            sx={{ marginTop: '1rem', width: '100% !important' }}
          >
            Sign
          </SolidButton>
        </Link>
      </Grid>
    </Grid>
  );
}
